export function productsMapper(products) {
  console.log(products.map(productMapper));
  return products.map(productMapper);
}

export function productMapper(product, index) {
  const {
    ProductID,
    ProductItemID,
    ProductUrl,
    ProductName,
    ProductNameHtml,
    MainImage,
    Brand,
    ProductList,
    ShortDescription,
    Currency,
    Category,
    Dimension35 = '',
    Dimension36 = '',
    Dimension37 = '',
    Dimension38 = '',
    Dimension39 = '',
    Dimension40 = '',
    StarRatingText,
    AverageRating,
    InactiveColor,
    ActiveColor,
    IsRatingEnabled,
    isBazaarvoiceActivated,
    VariantCount,
    ProductEanNumber,
    product_franchise,
    product_label,
    product_quantity_range,
    MikmakAddtocart,
  } = product;

  return {
    productId: ProductID,
    productItemId: ProductItemID,
    productName: ProductName,
    productNameHtml: ProductNameHtml,
    productUrl: ProductUrl,
    starRatingText: StarRatingText,
    averageRating: AverageRating,
    inactiveColor: InactiveColor,
    activeColor: ActiveColor,
    isRatingEnabled: IsRatingEnabled,
    IsBazaarvoiceActivated:isBazaarvoiceActivated,
    VariantCount:VariantCount,
    ProductEanNumber:ProductEanNumber,
    packshot: {
      src: MainImage,
      alt: ''
    },

    productShortDescription: ShortDescription,

    tagging: {
      id: ProductEanNumber,
      name: ProductName,
      position: index,
      brand: Brand,
      productlist: ProductList,
      currency: Currency,
      category: Category,
      dimension35: Dimension35,
      dimension36: Dimension36,
      dimension37: Dimension37,
      dimension38: Dimension38,
      dimension39: Dimension39,
      dimension40: Dimension40,
      product_franchise:product_franchise,
      product_label:product_label,
      product_quantity_range:product_quantity_range
    },
    MikMakAddToCart:MikmakAddtocart
  };
}
